import { render, staticRenderFns } from "./AdminTicketModal.vue?vue&type=template&id=60e00c55&scoped=true"
import script from "./AdminTicketModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminTicketModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdminTicketModal.vue?vue&type=style&index=0&id=60e00c55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e00c55",
  null
  
)

export default component.exports